import { motion } from 'framer-motion';
import { useState,useEffect } from 'react';
import axios from "axios";
import { Search, GraduationCap } from "lucide-react";
import { Link } from "react-router-dom";
import { Building2, Library, Monitor, HeartPulse, Globe, Users, FlaskConical, Cloud } from 'lucide-react';

export default function DepartmentEEE({  
  accent = "#115e32",
  pageTitle = "Department of Electrical and Electronic Engineering | University of Creative Technology Chittagong",
}) {
	useEffect(() => {
		document.title = pageTitle;
	}, [pageTitle]);
	const [activeTab, setActiveTab] = useState('Overview');
	const [faculty, setFaculty] = useState([]);
	const [search, setSearch] = useState("");
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	const [notices, setNotices] = useState([]);
	const [news, setNews] = useState([]);
	
	const [courses, setCourses] = useState({});
	const [selectedSemester, setSelectedSemester] = useState("Semester Number: 1");
	const [loadingCourses, setLoadingCourses] = useState(false);
	
	const [course, setCourse] = useState({});
	const [selectedSem, setSelectedSem] = useState("Semester Number: 1");
	const [loadingC, setLoadingC] = useState(false);
	
	const facultyPost = async () => {
		setLoading(true);
		setError(null);

		try {
			const payload = {
				userId: import.meta.env.VITE_API_USER,
				password: import.meta.env.VITE_API_PASS,
				department_id:"8",
				designation_id:"0",
		    };
			const api = axios.create({
				baseURL: import.meta.env.VITE_API_BASE_URL,
				headers: { "Content-Type": "application/json" },
			});
			const response = await api.post("/teacher-list", payload);			
			
			// Loop data (array)
			setFaculty(response.data || []);			
		} catch (err) {
		   setError(err.message || "Something went wrong");		   
		} finally {
		  setLoading(false);
		}
	};
	
	const noticePost = async () => {
		setLoading(true);
		setError(null);
		try {
			const payload = {
				userId: import.meta.env.VITE_API_USER,
				password: import.meta.env.VITE_API_PASS,
				department_id:"8",	
		    };
			const api = axios.create({
				baseURL: import.meta.env.VITE_API_BASE_URL,
				headers: { "Content-Type": "application/json" },
			});
			const response = await api.post("/recent-notice", payload);
			
			setNotices(response.data);			
		} catch (err) {
		   setError(err.message || "Something went wrong");		   
		} finally {
		  setLoading(false);
		}
	};
	
	const newsPost = async () => {
		setLoading(true);
		setError(null);

		try {
			const payload = {
				userId: import.meta.env.VITE_API_USER,
				password: import.meta.env.VITE_API_PASS,
				department_id:"8",
		    };
			const api = axios.create({
				baseURL: import.meta.env.VITE_API_BASE_URL,
				headers: { "Content-Type": "application/json" },
			});
			const response = await api.post("/recent-news", payload);
			const data = response.data.slice(0, 48);
			
			// Loop data (array)
			setNews(response.data || []);
			
		} catch (err) {
		   setError(err.message || "Something went wrong");		   
		} finally {
		  setLoading(false);
		}
	};
	const coursePost = async () => {
		setLoadingCourses(true);
		setError(null);

		try {
			const payload = {
				userId: import.meta.env.VITE_API_USER,
				password: import.meta.env.VITE_API_PASS,
				department_id:"8",
				programme_id:"1",
		    };
			const api = axios.create({
				baseURL: import.meta.env.VITE_API_BASE_URL,
				headers: { "Content-Type": "application/json" },
			});
			const response = await api.post("/program-syllabus", payload);
			console.log();
			setCourses(response.data);
			
		} catch (err) {
		   setError(err.message || "Something went wrong");		   
		} finally {
		  setLoadingCourses(false);
		}
	};
	
	const offerCourse = async () => {
		setLoadingC(true);
		setError(null);

		try {
			const payload = {
				userId: import.meta.env.VITE_API_USER,
				password: import.meta.env.VITE_API_PASS,
				department_id:"8",
				programme_id:"1",
		    };
			const api = axios.create({
				baseURL: import.meta.env.VITE_API_BASE_URL,
				headers: { "Content-Type": "application/json" },
			});
			const response = await api.post("/course-offered", payload);
			
			setCourse(response.data);
			
		} catch (err) {
		   setError(err.message || "Something went wrong");		   
		} finally {
		  setLoadingC(false);
		}
	};
	
	useEffect(() => {		
		facultyPost();
		noticePost();
		newsPost();
		coursePost();
		offerCourse();
	}, []);
	
	const filteredFaculty = faculty.filter((f) =>
		[f.name, f.department, f.designation]
		  .join(" ")
		  .toLowerCase()
		  .includes(search.toLowerCase())
	);
	const menuItems = [
		'Overview', 'Tuition Fees', 'Financial Aid', 'Notice', 'News & Events', 'Videos', 'Faculty Members',
		'EEE Club', 'Research', 'Facilities', 'Course Curriculum', 'Course Offered', 'Contact Us'
	];
	const researchAreas = [
		'Power Systems & Smart Grid Technology',
		'Renewable Energy & Sustainable Power Systems',
		'Power Electronics & Energy Conversion',
		'RoboElectrical Machines & Drivestics',
		'Control Systems & Automation',
		'Embedded Systems & Microcontrollers'
	];
	const facilities = [
		{ icon: <FlaskConical className="w-10 h-10 text-[#016C94]" />, title: 'Well Equip Laboratories' },
		{ icon: <Building2 className="w-10 h-10 text-[#016C94]" />, title: 'Research Lab' },
		{ icon: <Library className="w-10 h-10 text-[#016C94]" />, title: 'Rich Library' },
		{ icon: <Monitor className="w-10 h-10 text-[#016C94]" />, title: 'Multimedia Classroom' },
		{ icon: <Users className="w-10 h-10 text-[#016C94]" />, title: 'Counseling of Weak Students' },
		{ icon: <Globe className="w-10 h-10 text-[#016C94]" />, title: 'Special Care for Foreign Students' },
		{ icon: <GraduationCap className="w-10 h-10 text-[#016C94]" />, title: 'Adequate AC Classroom' },
		{ icon: <HeartPulse className="w-10 h-10 text-[#016C94]" />, title: 'Health Care' },
		{ icon: <Cloud className="w-10 h-10 text-[#016C94]" />, title: 'Online Academic Services' },
	];
	
	
  const tabContents = {
    'Overview': (
      <>
        <h2 className="text-3xl font-bold text-[#016C94]">Electrical and Electronic Engineering</h2>
        <p className="mt-4 text-gray-700 leading-relaxed">The Department of Electrical and Electronic Engineering (EEE) at University of Creative Technology, Chittagong (also known as UCTC) is a place where brightest minds from all over the country and abroad assembles for a greater future. We want to go build a strong alumni association to exchange academic and professional knowledge and experience among the existing and former students of UCTC in the field of EEE. Our alumni will serve once in the top ranking universities as teachers and researchers and in the top companies all around the world as self-motivated software engineers and IT specialists. We organize various co-curricular and extra-curriculum activities. Such as Programming contest, Workshop, job Fair, The Debating Club, Seminar, Intra-Department Football/Cricket Tournament, Indoor Games, etc. Our students are well equipped to take the challenge to stand out as the leaders of tomorrow. We welcome all in our community who are willing to take the challenge and who are trying to be the best in their future. Welcome to our EEE Department.
		</p>
        <h3 className="text-2xl font-semibold text-[#016C94] mt-8">Vision</h3>
        <p>To produce competent professionals who shall be leaders in technology, industry and research at the national and international level.</p>

        <h3 className="text-2xl font-semibold text-[#016C94] mt-8">Mission</h3>
        <p>The mission of the Department of Electrical and Electronic Engineering (EEE) is to teach and prepare educated, skilled, & ethically sound computer scientists and engineers for leadership and professional careers and for advanced studies.</p>

        <h3 className="text-2xl font-semibold text-[#016C94] mt-8">Objectives</h3>
        <ul className="list-disc ml-8 space-y-2">
          <li>Apply knowledge of mathematics, science, engineering fundamentals, and specialization to conceptualize models.</li>
          <li>Design and develop solutions for complex engineering problems considering societal and environmental factors.</li>
          <li>Conduct investigations and synthesize data to provide valid conclusions.</li>
          <li>Use modern tools effectively and understand their limitations.</li>
          <li>Function effectively as an individual and team member or leader.</li>
          <li>Communicate effectively in both technical and societal contexts.</li>
          <li>Demonstrate understanding of ethics and professional responsibilities.</li>
        </ul>

        <h3 className="text-2xl font-semibold text-[#016C94] mt-8">Why Choose EEE?</h3>
        <p>The most important aspect of computer science is problem solving — an essential life skill. Students study software and hardware design to solve problems across business, science, and social domains. With analytical and critical thinking skills, they excel in fields like big data, cybersecurity, and AI. Computer Science is challenging but rewarding, giving that same joy as when one creates their first program.</p>

        <h3 className="text-2xl font-semibold text-[#016C94] mt-8">Specialty</h3>
        <ul className="list-decimal ml-8 space-y-2">
          <li>Power generation</li>
          <li>Grid infrastructure</li>
          <li>Power electronics</li>
          <li>Electric vehicles (EVs)</li>
          <li>Circuit design</li>
		  <li>VLSI design</li>
		  <li>Microelectronics and nanoelectronics</li>
		  <li>Embedded systems</li>
		  <li>Telecommunication engineering</li>
		  <li>Signal processing</li>
		  <li>Radio frequency (RF) engineering</li>
		  <li>Photonics and optics</li>
		  <li>Control systems engineering</li>
		  <li>Robotics</li>
		  <li>Mechatronics</li>
		  <li>Computer architecture</li>
		  <li>Machine learning and AI</li>
		  <li>Software engineering</li>
        </ul>

        <h3 className="text-2xl font-semibold text-[#016C94] mt-8">Spirituality</h3>
        <p>The Department provides an excellent academic environment, guided by top-tier faculty engaged in world-class research. Students are encouraged to pursue research and publications early in their academic careers, fostering innovation and scholarly excellence.</p>

        <h3 className="text-2xl font-semibold text-[#016C94] mt-8">Alumni</h3>
        <p>EEE UCTC is always grateful to its alumni for their guidance and support. Alumni are active in cultural events, seminars, programming contests, convocations, and more, maintaining strong ties with the department.</p>

        <h3 className="text-2xl font-semibold text-[#016C94] mt-8">Why Study Here?</h3>
        <p>UCTC offers 14 majors, 15 minors, and 100+ specialization areas. Beyond technical skills, it fosters social responsibility and justice, preparing students for ethical leadership in the global workforce.</p>
      </>
    ),

    'Tuition Fees': (
	<motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
		<h2 className="text-3xl font-bold text-[#016C94] mb-6">Tuition Fees Structure</h2>
		<div className="overflow-x-auto">
			<table className="min-w-full bg-white border border-gray-200 rounded-xl shadow-lg">
				<thead className="bg-[#016C94] text-white">
					<tr>
						<th className="py-3 px-6 text-left">Description</th>
						<th className="py-3 px-6 text-right">Amount (৳)</th>
					</tr>
				</thead>
				<tbody className="text-gray-700">
					{[
					{ label: 'Total Credits', value: '161' },
					{ label: 'Admission Fee (once, non-refundable)', value: '15,000' },
					{ label: 'Application Form Fee', value: '500' },
					{ label: 'Registration Fee (Per Semester)', value: '4,000' },
					{ label: 'Orientation Fee', value: '1,000' },
					{ label: 'Tuition Fee (Per Credit)', value: '3,400' },
					{ label: 'Development Fee', value: '1,500' }
					].map((row, i) => (
					<motion.tr
						key={i}
						initial={{ opacity: 0, y: 10 }}
						animate={{ opacity: 1, y: 0 }}
						transition={{ delay: i * 0.1 }}
						className="hover:bg-[#E6FAFE] transition"
						>
						<td className="py-3 px-6 font-medium">{row.label}</td>
						<td className="py-3 px-6 text-right">{row.value}</td>
					</motion.tr>
					))}
				</tbody>
				<tfoot className="bg-[#E6FAFE] text-[#016C94] font-semibold">
					<tr>
						<td className="py-3 px-6 text-left">Total Fee</td>
						<td className="py-3 px-6 text-right">5,97,400</td>
					</tr>
					<tr>
						<td className="py-3 px-6 text-left">After 50% Waiver</td>
						<td className="py-3 px-6 text-right">3,33,900</td>
					</tr>
				</tfoot>
			</table>
		</div>


		<motion.div
			className="mt-10 bg-gradient-to-r from-[#6BCCF2] to-[#016C94] text-white p-8 rounded-2xl shadow-lg text-center"
			initial={{ opacity: 0, scale: 0.9 }}
			animate={{ opacity: 1, scale: 1 }}
			transition={{ delay: 0.5 }}
			>
			<h3 className="text-2xl font-bold mb-3">Affordable Quality Education</h3>
			<p className="max-w-2xl mx-auto text-lg">UCTC offers one of the most affordable tuition structures while ensuring world-class academic excellence. We believe in empowering students with opportunities through financial waivers and merit-based scholarships.</p>
		</motion.div>
	</motion.div>
	),
    'Financial Aid': (
	<motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
		<h2 className="text-3xl font-bold text-[#016C94] mb-6">Financial Aid & Scholarships</h2>


		<motion.div className="bg-gradient-to-r from-[#E6FAFE] to-[#6BCCF2] p-8 rounded-2xl shadow-lg mb-8">
			<h3 className="text-2xl font-semibold text-[#016C94] mb-4">Financial Aid Overview</h3>
			<p className="text-gray-700 leading-relaxed">UCTC emphasizes providing assistance in case of any interruption in continuing study as well as motivating students with different scholarships in the following segments:</p>


			<ul className="list-disc ml-8 mt-4 text-gray-700 space-y-2">
				<li>Poor and meritorious students</li>
				<li>Special waiver for siblings, offspring of freedom fighters, tribal students, and national-level players</li>
				<li>Waiver on excellent results in semesters</li>
				<li>Need-based scholarships</li>
			</ul>
		</motion.div>


		<motion.div
		className="bg-white/90 backdrop-blur-md p-8 rounded-2xl shadow-lg border border-[#6BCCF2]"
		initial={{ opacity: 0, scale: 0.95 }}
		animate={{ opacity: 1, scale: 1 }}
		transition={{ delay: 0.4 }}
		>
			<h3 className="text-2xl font-semibold text-[#016C94] mb-4">Policies & Guidelines</h3>
			<ul className="list-disc ml-8 text-gray-700 space-y-2">
				<li>Scholarship/financial aid will be awarded to students who meet the eligibility criteria*</li>
				<li>All applications for scholarship/tuition waiver must be submitted within the university-announced deadline</li>
				<li>Only one of the waivers will be awarded to a particular student</li>
				<li>All tuition fee waivers depend on fund availability</li>
				<li>Students applying for renewal must take a minimum 15 credits course load</li>
			</ul>
			<p className="text-sm text-gray-600 mt-4 italic">*The financial aid policy is subject to change as guided by exigencies.</p>
		</motion.div>


		<motion.div
		className="mt-10 bg-gradient-to-r from-[#016C94] to-[#6BCCF2] text-white p-8 rounded-2xl shadow-lg text-center"
		initial={{ opacity: 0, y: 20 }}
		animate={{ opacity: 1, y: 0 }}
		transition={{ delay: 0.6 }}
		>
			<h3 className="text-2xl font-bold mb-3">Empowering Dreams through Financial Support</h3>
			<p className="max-w-2xl mx-auto text-lg">UCTC believes that financial limitations should never hinder a student’s dream of education. Our extensive financial aid programs ensure that every student, regardless of background, has access to world-class education and opportunities.</p>
		</motion.div>
	</motion.div>
	),
    'Notice': (<>
		<motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
			<h2 className="text-3xl font-bold text-[#016C94] mb-6">Recent Notices</h2>
			{loading ? (
				<div className="flex justify-center py-10">
					<div className="animate-spin rounded-full h-12 w-12 border-4 border-[#016C94] border-t-transparent"></div>
				</div>
			) : (
				<div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
					{notices.map((notice, index) => (
					<motion.div
					key={notice.id}
					initial={{ opacity: 0, scale: 0.9 }}
					animate={{ opacity: 1, scale: 1 }}
					transition={{ delay: index * 0.1 }}
					className="bg-gradient-to-br from-[#E6FAFE] to-[#6BCCF2] p-6 rounded-2xl shadow-lg hover:shadow-2xl transition-transform hover:-translate-y-2"
					>
					<h3 className="text-xl font-semibold text-[#016C94] mb-2">{notice.head_line}</h3>
					<p className="text-sm text-gray-600 mb-4">Date: {new Date(notice.date).toLocaleDateString()}</p>
					<a href={`/notice/${notice.id}`} target="_blank" rel="noopener noreferrer" className="inline-block text-white bg-[#016C94] px-4 py-2 rounded-full text-sm font-medium hover:bg-[#034f6e] transition">View Details</a>
				</motion.div>
				))}
			</div>
			)}
		</motion.div>
	</>),
    'News & Events': (
	<>
		<div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {news.length > 0 ? (
            news.map((item) => (
              <div
                key={item.id}
                className="bg-white rounded-xl shadow hover:shadow-lg transition duration-300 overflow-hidden"
              >
                {/* Image */}
                <img
                  src={
                    item.images_path
                      ? import.meta.env.VITE_API_SOURCE_URL + item.images_path
                      : "https://via.placeholder.com/400x250?text=No+Image"
                  }
                  alt={item.head_line}
                  className="w-full h-48 object-cover"
                />

                {/* Content */}
                <div className="p-4">
                  <h3 className="text-lg font-semibold text-gray-800 mb-2 line-clamp-2">
                    {item.head_line}
                  </h3>
                  <p className="text-sm text-gray-500 mb-3">
                    {new Date(item.date).toLocaleDateString()}
                  </p>

                  <Link
                    to={`/news/${item.id}`}
                    className="inline-block bg-[#014864] text-white text-sm font-medium px-4 py-2 rounded-lg hover:bg-gray-700 transition"
                  >
                    Read More
                  </Link>
                </div>
              </div>
            ))
          ) : (
            <p className="col-span-4 text-center text-gray-500">
              No news found.
            </p>
          )}
        </div>
	</>),
    'Videos': <p>Department-related videos, tutorials, and lectures.</p>,
    'Faculty Members': (
	<>
		<div className="max-w-3xl mx-auto px-6 mb-10">
			<div className="flex items-center bg-white shadow-lg rounded-full px-4 py-2 border border-amber-100">
			  <Search className="text-[#016C94] mr-2" />
			  <input
				type="text"
				placeholder="Search by name, department, or designation..."
				value={search}
				onChange={(e) => setSearch(e.target.value)}
				className="flex-1 outline-none bg-transparent text-[#016C94]"
			  />
			</div>
		</div>
		{/* Faculty Cards Section */}
		<section className="max-w-7xl mx-auto px-6 pb-16">
        {loading ? (
          <div className="text-center text-[#6BCCF2] font-medium">
            Loading faculty data...
          </div>
        ) : filteredFaculty.length === 0 ? (
          <div className="text-center text-[#6BCCF2] font-medium">
            No faculty found.
          </div>
        ) : (
          <motion.div
            layout
            className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8"
          >
            {filteredFaculty.map((f, index) => (
              <motion.div
                key={index}
                whileHover={{ scale: 1.03 }}
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.05 }}
                className="bg-white rounded-2xl shadow-md border border-amber-100 p-6 flex flex-col items-center text-center"
              >
                <img
                  src={`${import.meta.env.VITE_API_SOURCE_URL}/${f.picture ? f.picture : "assets/images/profile-picture.png"}` }
                  alt={f.name}
                  className="w-32 h-32 object-cover rounded-full shadow-md mb-4 border border-[#016C94]"
                />
                <h3 className="text-xl font-bold text-[#016C94] mb-1">
                  {f.name}
                </h3>
                <p className="text-[#6BCCF2] font-medium">{f.designation_name}</p>
                <p className="text-[#016C94] text-sm mb-3">{f.department_name}</p>

                <div className="text-sm text-[#016C94] mb-2">
                  <p>
                    <strong>Education:</strong> {f.education}
                  </p>
                  <p>
                    <strong>Mobile:</strong> {f.mobile_number}
                  </p>
                  <p>
                    <strong>Email:</strong> {f.email}
                  </p>
                </div>

                <a
                  href={`/profile/${f.teacher_id}`}
                  target="_blank"
                  className="mt-3 inline-block bg-[#6BCCF2] text-white px-4 py-2 rounded-full font-semibold hover:bg-amber-800 transition-all"
                >
                  View Profile
                </a>
              </motion.div>
            ))}
          </motion.div>
        )}
		</section>
	</>
	),
    'EEE Club': (
		<>
			<h2>Electrical & Electronic Engineering Club (EEE Club)</h2>

			<p>
				<strong>Electrical & Electronic Engineering Club (EEE Club)</strong> is a student-led platform of the Department of Electrical and Electronic Engineering at the University of Creative Technology Chittagong (UCTC). The club is dedicated to developing students' technical knowledge, practical skills, creativity, leadership, teamwork, and problem-solving abilities through a wide range of academic, technical, professional, and social activities.
			</p>

			<p>
				EEE Club provides students with opportunities to explore electrical and electronic engineering beyond the classroom. Through hands-on projects, technical competitions, workshops, seminars, robotics activities, and industry-oriented programs, the club encourages innovation, experimentation, and the practical application of engineering knowledge.
			</p>

			<h3>Our Activities</h3>

			<h4>1. Technical Programs</h4>
			<p>
				EEE Club organizes technical competitions, circuit design challenges, robotics events, programming activities, electronics projects, and hands-on programs that help students strengthen their practical engineering skills.
			</p>

			<h4>2. Seminars & Workshops</h4>
			<p>
				The club regularly arranges seminars, workshops, and guest lectures featuring experienced engineers, academicians, researchers, and industry professionals. These programs provide students with valuable insights into emerging technologies and career opportunities in electrical and electronic engineering.
			</p>

			<h4>3. Fresher Orientation</h4>
			<p>
				EEE Club welcomes newly admitted students through Fresher Orientation Programs, introducing them to the department, faculty members, laboratories, academic environment, student activities, and opportunities available through the club.
			</p>

			<h4>4. Robotics & Innovation</h4>
			<p>
				The club encourages students to participate in robotics, automation, IoT, embedded systems, and innovative technology projects. These activities provide students with practical experience in designing and developing technology-based solutions.
			</p>

			<h4>5. Industrial Visits</h4>
			<p>
				EEE Club organizes industrial visits to power plants, electrical substations, manufacturing facilities, technology companies, and other relevant organizations. These visits help students understand real-world electrical and electronic engineering operations.
			</p>

			<h4>6. Project & Research Activities</h4>
			<p>
				The club encourages students to develop innovative projects and participate in research activities related to renewable energy, power systems, electronics, communication, automation, artificial intelligence, IoT, and emerging technologies.
			</p>

			<h4>7. Social & Community Activities</h4>
			<p>
				EEE Club also participates in social and community initiatives such as tree plantation, blood donation campaigns, technology awareness programs, charity activities, and other community service initiatives that promote social responsibility among students.
			</p>
		</>
	),
    'Research': (
	<motion.div
	initial={{ opacity: 0, y: 30 }}
	animate={{ opacity: 1, y: 0 }}
	transition={{ duration: 0.8 }}
	className="relative"
	>
		<div className="absolute inset-0 bg-gradient-to-br from-[#E6FAFE] via-[#6BCCF2]/30 to-[#016C94]/40 rounded-3xl blur-2xl opacity-70 animate-pulse"></div>


		<div className="relative z-10">
			<h2 className="text-3xl font-bold text-[#016C94] mb-6 text-center">Innovative Research at UCTC EEE</h2>


			<motion.p
			initial={{ opacity: 0, y: 20 }}
			animate={{ opacity: 1, y: 0 }}
			transition={{ delay: 0.2 }}
			className="text-gray-700 leading-relaxed text-lg text-center max-w-4xl mx-auto mb-10"
			>
			The Department of Electrical and Electronic Engineering (EEE) at UCTC is committed to advancing knowledge through innovative, practical, and technology-driven research. Our research focuses on developing smart, efficient, sustainable, and reliable solutions to address the challenges of modern electrical and electronic systems. Our research activities bring together faculty members, students, industry professionals, and national and international academic partners. Through experimental research, simulation, prototyping, and interdisciplinary collaboration, we aim to contribute to technological innovation and sustainable development. Our research findings are shared through conferences, seminars, workshops, publications, and professional networks.
			</motion.p>


			<motion.h3
			initial={{ opacity: 0, y: 20 }}
			animate={{ opacity: 1, y: 0 }}
			transition={{ delay: 0.4 }}
			className="text-2xl font-semibold text-[#016C94] text-center mb-6"
			>
			Our Research Areas
			</motion.h3>


			<motion.div
			className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6 justify-center"
			initial="hidden"
			animate="visible"
			variants={{
			hidden: {},
			visible: {
			transition: { staggerChildren: 0.1 }
			}
			}}
			>
				{researchAreas.map((area, i) => (
				<motion.div
				key={i}
				whileHover={{ scale: 1.1, y: -5 }}
				whileTap={{ scale: 0.95 }}
				initial={{ opacity: 0, y: 10 }}
				animate={{ opacity: 1, y: 0 }}
				transition={{ delay: i * 0.1 }}
				className="bg-gradient-to-br from-[#E6FAFE] via-[#6BCCF2] to-[#016C94] text-center p-4 rounded-2xl shadow-lg text-[#016C94] font-medium hover:text-white hover:shadow-2xl cursor-pointer transition duration-300"
				>
					{area}
				</motion.div>
				))}
			</motion.div>


			<motion.div
			className="mt-16 bg-gradient-to-r from-[#016C94] to-[#6BCCF2] text-white p-10 rounded-3xl shadow-2xl text-center"
			initial={{ opacity: 0, scale: 0.9 }}
			animate={{ opacity: 1, scale: 1 }}
			transition={{ delay: 0.8 }}
			>
				<h3 className="text-2xl font-bold mb-4">Pioneering the Future of Technology</h3>
				<p className="max-w-3xl mx-auto text-lg">Our department fosters a research culture that inspires curiosity, critical thinking, and technological excellence. We empower our students and faculty to explore new horizons, turning creative ideas into real-world innovations that shape the digital future.</p>
			</motion.div>
		</div>
	</motion.div>
	),
    'Facilities': (
	<motion.div
	initial={{ opacity: 0, y: 30 }}
	animate={{ opacity: 1, y: 0 }}
	transition={{ duration: 0.8 }}
	>
		<div className="text-center mb-10">
			<h2 className="text-3xl font-bold text-[#016C94] mb-4">Our Facilities</h2>
			<p className="text-gray-700 max-w-3xl mx-auto text-lg">Get involved and stay up to date with what's happening at the Department of Electrical and Electronic Engineering. We ensure an inspiring learning environment equipped with modern resources and supportive infrastructure.</p>
		</div>


		<motion.div
		className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8"
		initial="hidden"
		animate="visible"
		variants={{
		hidden: {},
		visible: { transition: { staggerChildren: 0.1 } }
		}}
		>
			{facilities.map((facility, index) => (
			<motion.div
			key={index}
			initial={{ opacity: 0, scale: 0.9 }}
			animate={{ opacity: 1, scale: 1 }}
			transition={{ delay: index * 0.1 }}
			whileHover={{ scale: 1.05, y: -5 }}
			whileTap={{ scale: 0.95 }}
			className="bg-gradient-to-br from-[#E6FAFE] via-[#6BCCF2]/70 to-[#016C94]/60 p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 text-center backdrop-blur-sm"
			>
				<div className="flex justify-center mb-4">{facility.icon}</div>
				<h3 className="text-xl font-semibold text-[#016C94]">{facility.title}</h3>
			</motion.div>
			))}
		</motion.div>


		<motion.div
		className="mt-16 bg-gradient-to-r from-[#016C94] to-[#6BCCF2] text-white p-10 rounded-3xl shadow-2xl text-center"
		initial={{ opacity: 0, y: 20 }}
		animate={{ opacity: 1, y: 0 }}
		transition={{ delay: 0.5 }}
		>
			<h3 className="text-2xl font-bold mb-3">Modern Learning Environment</h3>
			<p className="max-w-2xl mx-auto text-lg">At UCTC EEE, we believe that the right environment nurtures innovation. Our world-class facilities ensure every student experiences hands-on learning, comfort, and access to cutting-edge technology.</p>
		</motion.div>
	</motion.div>
	),
    'Course Curriculum': (<>
		<motion.section layout className="rounded-2xl bg-white p-6 shadow-lg border border-amber-100">
		  <div className="flex items-center justify-between">
			<h3 className="text-xl font-bold text-[#014864]">Semester-wise Courses</h3>
			<div className="text-sm text-gray-600">{loadingCourses ? "Loading courses..." : "Select semester to view details"}</div>
		  </div>

		  <div className="mt-4 flex gap-2 overflow-auto pb-2">
			{Object.keys(courses).map((sem) => (
			  <button
				key={sem}
				onClick={() => setSelectedSemester(sem)}
				className={`whitespace-nowrap px-3 py-1 rounded-full border ${selectedSemester === sem ? "bg-amber-700 text-white" : "bg-[#E6FAFE] text-[#014864]"}`}
			  >
				{sem.replace("Semester Number: ", "Semester ")}
			  </button>
			))}
		  </div>

		  <div className="mt-4">
			<table className="w-full text-sm border-collapse">
			  <thead>
				<tr className="bg-[#E6FAFE]">
				  <th className="p-2 text-left border-b">#</th>
				  <th className="p-2 text-left border-b">Code</th>
				  <th className="p-2 text-left border-b">Title</th>
				  <th className="p-2 text-left border-b">Credit</th>
				  <th className="p-2 text-left border-b">Pre-req</th>
				</tr>
			  </thead>
			  <tbody>
				{courses[selectedSemester] && courses[selectedSemester].map((c) => (
				  <tr key={c.course_id} className="hover:bg-[#E6FAFE]">
					<td className="p-2 align-top border-b">{c.sl}</td>
					<td className="p-2 align-top border-b font-mono">{c.actual_code}</td>
					<td className="p-2 align-top border-b">{c.course_title}</td>
					<td className="p-2 align-top border-b">{c.credit_hours}</td>
					<td className="p-2 align-top border-b">{c.pre_requisite || "—"}</td>
				  </tr>
				))}
			  </tbody>
			</table>
		  </div>
		</motion.section>
	</>),
    'Course Offered': (<>
		<motion.section layout className="rounded-2xl bg-white p-6 shadow-lg border border-amber-100">
		  <div className="flex items-center justify-between">
			<h3 className="text-xl font-bold text-[#014864]">Semester-wise Offered Courses (Last Semester)</h3>
			<div className="text-sm text-gray-600">{loadingC ? "Loading courses..." : "Select semester to view details"}</div>
		  </div>

		  <div className="mt-4 flex gap-2 overflow-auto pb-2">
			{Object.keys(course).map((sem) => (
			  <button
				key={sem}
				onClick={() => setSelectedSem(sem)}
				className={`whitespace-nowrap px-3 py-1 rounded-full border ${selectedSem === sem ? "bg-amber-700 text-white" : "bg-[#E6FAFE] text-[#014864]"}`}
			  >
				{sem.replace("Semester Number: ", "Semester ")}
			  </button>
			))}
		  </div>

		  <div className="mt-4">
			<table className="w-full text-sm border-collapse">
			  <thead>
				<tr className="bg-[#E6FAFE]">
				  <th className="p-2 text-left border-b">#</th>
				  <th className="p-2 text-left border-b">Code</th>
				  <th className="p-2 text-left border-b">Title</th>
				  <th className="p-2 text-left border-b">Credit</th>				  
				</tr>
			  </thead>
			  <tbody>
				{course[selectedSem] && course[selectedSem].map((c) => (
				  <tr key={c.course_id} className="hover:bg-[#E6FAFE]">
					<td className="p-2 align-top border-b">{c.sl}</td>
					<td className="p-2 align-top border-b font-mono">{c.actual_code}</td>
					<td className="p-2 align-top border-b">{c.course_title}</td>
					<td className="p-2 align-top border-b">{c.credit_hours}</td>					
				  </tr>
				))}
			  </tbody>
			</table>
		  </div>
		</motion.section>
	</>
	),
    'Contact Us': (
      <>
        <h3 className="text-2xl font-semibold text-[#016C94]">Department Contact Info</h3>
        <p><strong>Address:</strong> Chandgaon Police Station, 1084, Shah Amanat Bridge Connecting Road, Chittagong 4212</p>
        <p><strong>Phone:</strong> 01940481808</p>
        <p><strong>Email:</strong> EEE@uctc.edu.bd</p>
        <p><strong>Office Hours:</strong> Mon – Sat 9:00A.M. – 5:00P.M.</p>
        <div className="mt-4">
          <h4 className="text-xl font-semibold text-[#016C94]">Social Info</h4>
          <div className="flex space-x-4 mt-2">
            <a href="#" className="text-[#016C94] hover:underline">Facebook</a>
            <a href="#" className="text-[#016C94] hover:underline">LinkedIn</a>
            <a href="#" className="text-[#016C94] hover:underline">YouTube</a>
          </div>
        </div>
      </>
    )
  };

  return (
    <div className="min-h-screen flex flex-col md:flex-row bg-gradient-to-b from-[#E6FAFE] via-[#6BCCF2] to-[#016C94] text-gray-900">
      {/* Sidebar Tabs */}
      <aside className="md:w-64 w-full  bg-white/90 backdrop-blur-md shadow-lg p-6 overflow-y-auto z-20 rounded-2xl">
        <h2 className="text-2xl font-bold text-[#016C94] mb-6 text-center md:text-left">Department Tabs</h2>
        <div className="flex md:flex-col flex-wrap justify-center md:justify-start gap-3">
          {menuItems.map((item) => (
            <button
              key={item}
              onClick={() => setActiveTab(item)}
              className={`px-4 py-2 rounded-full font-medium border transition text-sm md:text-base ${activeTab === item ? 'bg-[#016C94] text-white' : 'bg-white text-[#016C94] hover:bg-[#E6FAFE]'}`}
            >
              {item}
            </button>
          ))}
        </div>
      </aside>

      {/* Main Tab Content */}
      <main className="md:ml p-6 md:p-10 flex-1">
		<motion.section
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          className="bg-gradient-to-r from-[#016C94] to-[#6BCCF2] text-white p-10 md:p-12 rounded-3xl shadow-xl mb-10 text-center md:text-left"
        >
          <h1 className="text-3xl md:text-4xl font-bold mb-4">Department of Electrical and Electronic Engineering</h1>
          <p className="text-base md:text-lg max-w-3xl mx-auto md:mx-0">Welcome to the EEE Department of University of Creative Technology, Chittagong (UCTC), where innovation meets education. We nurture creative thinkers and problem solvers prepared to lead in technology, industry, and research.</p>
          <div className="mt-6 flex flex-col md:flex-row gap-4 justify-center md:justify-start">
            <button className="bg-white text-[#016C94] px-5 py-2 rounded-full font-semibold hover:bg-[#E6FAFE] transition">Apply Online</button>
            <button className="border border-white px-5 py-2 rounded-full font-semibold hover:bg-white hover:text-[#016C94] transition">Download Brochure</button>
          </div>
        </motion.section>
        <motion.section
          key={activeTab}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="bg-white/90 backdrop-blur-md p-8 rounded-2xl shadow-lg min-h-[70vh]"
        >
          {tabContents[activeTab]}
        </motion.section>
      </main>
    </div>
  );
}
